import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(4),
  },
  subContent: {
    display: 'flex',
    gap: theme.spacing(3),
    flexDirection: 'column',
  },
  rowTitle: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '0.15',
    color: '#381E1C',
  },
  lightText: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0.25',
    color: theme.palette.labraText.description,
  },
}))
